import { MODULES } from '@app/shared/constants/shared.constant';

export const MENU_ROUTES: {
    module: MODULES;
    headerOrder: number;
    homePageOrder: number;
    css: string;
}[] = [
    {
        module: MODULES.ASSETS,
        headerOrder: 1,
        homePageOrder: 1,
        css: 'genai-studio',
    },
    {
        module: MODULES.TESTING,
        headerOrder: 2,
        homePageOrder: 2,
        css: 'testing',
    },
    {
        module: MODULES.MANAGEMENT,
        headerOrder: 3,
        homePageOrder: 3,
        css: 'management',
    },
    {
        module: MODULES.MONITOR,
        headerOrder: 4,
        homePageOrder: 4,
        css: 'monitor',
    },
];
